require('./duengungDialog');
require('./duengungUtils');
const $ = require('jquery');

/**
 * duengung_hideFields
 * @param element
 */
window.duengung_hideFields = function(element) {
  if (parseInt($(element).val()) === 2) {
    $('.onlyMethodeMineralisch').addClass('display-none');
  } else {
    $('.onlyMethodeMineralisch').removeClass('display-none');
  }
};

/**
 * duengung_sortWithParameter
 * @param sort
 * @param recordID
 * @param hasOpenSections
 * @param isAbgegeben
 */
window.duengung_sortWithParameter = function(sort, recordID, hasOpenSections, isAbgegeben) {
  const checked = $('div[data-section-uid]').has('input:checked').map(function() {
    return parseInt($(this).data('section-uid'));
  }).get();

  const activeButtons = $('.active-buttons');
  if (activeButtons.length > 0) {
    activeButtons.removeClass('active');

    const firstLevelButton = $('#show-first-level');
    if (sort === 'betrieb') {
      firstLevelButton.text(LANG_STRINGS.anlagen);
    } else if (sort === 'sorte' || sort === 'pflanzjahr') {
      firstLevelButton.text(LANG_STRINGS.betriebe);
    }
  }

  const ListAufzeichnungFlaechenDuengung = new AjaxItem('aufzeichnungFlaechenDuengung', {}, {}, 'aufzeichnungen');
  ListAufzeichnungFlaechenDuengung.poster({
    checked: checked, sortby: sort, recordID: recordID, hasOpenSections: hasOpenSections, isAbgegeben: isAbgegeben,
  });
};

/**
 * duengung_showHideLockedDataset
 * @param currentElement
 * @param recordID
 * @param hasOpenSections
 * @param isAbgegeben
 */
window.duengung_showHideLockedDataset = function(currentElement, recordID, hasOpenSections, isAbgegeben) {
  const checked = $('div[data-section-uid]').has('input:checked').map(function() {
    return parseInt($(this).data('section-uid'));
  }).get();

  const ListAufzeichnungFlaechenDuengung = new AjaxItem('aufzeichnungFlaechenDuengung', {}, {}, 'aufzeichnungen');
  ListAufzeichnungFlaechenDuengung.poster({
    checked: checked,
    recordID: recordID,
    hasOpenSections: hasOpenSections,
    isAbgegeben: isAbgegeben,
    showHideLockedDataset: 1,
  });

  if ($(currentElement).find('span').hasClass('show-txt-0')) {
    $(currentElement).find('span').html(LANG_STRINGS.gesperrteAbschnitteAusblenden);
    $(currentElement).find('span').removeClass('show-txt-0').addClass('show-txt-1');
  } else {
    $(currentElement).find('span').html(LANG_STRINGS.gesperrteAbschnitteEinblenden);
    $(currentElement).find('span').removeClass('show-txt-1').addClass('show-txt-0');
  }
};

/**
 *
 * @returns {{alleAbschnitteId: *[], summe: *, abschnitte: {}}}
 */
window.duengung_buildAbschnittData = function(preload = false) {
  let dataSectionID = $('[data-section-uid]');
  dataSectionID.hasNot('input:checked').map(function() {
    duengung_resetAbschnittData($(this));
  });

  const tableMittel = $('#table-mittel');
  const tableMittelChildren = tableMittel.children(':not(.row-table__head)');

  const abschnitte = {};
  let sumFlaeche = 0;
  dataSectionID.has('input:checked').map(function() {
    sumFlaeche += Number($(this).find('input[name="flaeche"]').val());
  });

  // Nährstoffe
  const naehrstoffe = {};
  const alleNaehrstoffeId = [];
  $('div.naehrstoff-gehalt').not('.display-none').each(function() {
    const naherstoffID = $(this).data('naehrstoff-id');

    alleNaehrstoffeId.push(naherstoffID);
    naehrstoffe[naherstoffID] = {
      id: naherstoffID, gehalt: Number($(this).find('input.naehrstoff-prozent').val()),
    };
  });

  dataSectionID.has('input:checked').map(function() {
    const abschnittFlaeche = Number($(this).find('input[name="flaeche"]').val());
    const abschnittID = Number($(this).attr('data-section-uid'));
    const abschnittRow = $(this);

    let mittelAbschnitt = {};
    let allMittelAbschnittID = [];
    if (tableMittelChildren.length > 0) {
      tableMittelChildren.each(function() {
        const mittelKey = $(this).data('psm-key') + '-' + $(this).data('psm-id');

        const mittelmenge = Number($(this).find('.list-mengeGesamt').val());

        var mittelmengeNeu;
        if (preload === true) {
          mittelmengeNeu = Number(abschnittRow.find('.section-detail-mittel[data-psm-id="' + $(this).data('psm-id') + '"][data-psm-key="' + $(this).data('psm-key') + '"]').find('.spray-amount-abschnitt').val());
        } else {
          //abrunden
          mittelmengeNeu = roundMittelmenge(abschnittFlaeche / sumFlaeche * mittelmenge, DUENGUNG_MITTELMENGE_GESAMT_MITTELMENGE_ABSCHNITT_AUFRUNDEN);
        }
        const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeNeu * 10000 / abschnittFlaeche);

        mittelAbschnitt[mittelKey] = {
          id: mittelKey, name: $(this).find('.list-mittelName').val(), dataKey: $(this).data('psm-key'), psmID: $(this).data('psm-id'), mittelmenge: mittelmengeNeu, mittelmengeProHa: mittelmengeProHaNeu, naehrstoffe: naehrstoffe, alleNaehrstoffeId: alleNaehrstoffeId, sectionID: abschnittID,
        };

        allMittelAbschnittID.push(mittelKey);
      });
    }

    abschnitte[abschnittID] = {
      id: abschnittID, flaeche: abschnittFlaeche, mittel: mittelAbschnitt, alleMittelId: allMittelAbschnittID,
    };
  });

  // Abschnitt-IDs
  let alleAbschnitteID = [];
  $.each(abschnitte, function(k, v) {
    alleAbschnitteID.push(v.id);
  });

  // Summe
  let sumMittel = {};
  let allMittelID = [];
  if (tableMittelChildren.length > 0) {
    tableMittelChildren.each(function() {
      const mittelKey = $(this).data('psm-key') + '-' + $(this).data('psm-id');

      const mittelmenge = Number($(this).find('.list-mengeGesamt').val());
      const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmenge / sumFlaeche * 10000);

      sumMittel[mittelKey] = {
        id: mittelKey, name: $(this).find('.list-mittelName').val(), psmID: $(this).data('psm-id'), dataKey: $(this).data('psm-key'), naehrstoffe: naehrstoffe, alleNaehrstoffeId: alleNaehrstoffeId, mittelmenge: mittelmenge, mittelmengeProHa: mittelmengeProHaNeu,
      };

      allMittelID.push(mittelKey);
    });
  }

  const summe = {
    flaeche: sumFlaeche, mittel: sumMittel, alleMittelId: allMittelID,
  };

  var summeNeu;
  if (preload === true) {
    summeNeu = summe;
  } else {
    summeNeu = duengung_recalculateSumme(summe, alleAbschnitteID, abschnitte);
  }

  return {
    abschnitte: abschnitte, alleAbschnitteId: alleAbschnitteID, summe: summeNeu,
  };
};

/**
 * duengung_calc
 * @param state
 * @param action
 * @returns {*&{summe: *, abschnitte: (*&{mittel: *})}}
 */
window.duengung_calc = function(state, action) {
  switch (action.type) {
      // mittelmenge summenzeile
    case 'SUMME_DUENGUNG_MITTELMENGE_CHANGING': {
      const mittelIdAction = action.mittelKey + '-' + action.mittelId;
      const mittelmenge = Number(action.mittelmenge);
      if (typeof action.noCalc_sumMengeGesamt === 'undefined') {
        $('input.sumMengeGesamt').val(roundMittelmengeGui(mittelmenge));
      }

      const flaecheGesamt = state.alleAbschnitteId.map(id => state.abschnitte[id]).reduce((a, b) => b.flaeche + a, 0);

      // Nährstoffe
      const naehrstoffe = {};
      const alleNaehrstoffeId = [];
      $('div.naehrstoff-gehalt').not('.display-none').each(function() {
        const naherstoffID = $(this).data('naehrstoff-id');

        alleNaehrstoffeId.push(naherstoffID);
        naehrstoffe[naherstoffID] = {
          id: naherstoffID, gehalt: Number($(this).find('input.naehrstoff-prozent').val()),
        };
      });

      if (!state.summe.mittel[mittelIdAction]) {
        state.summe.mittel[mittelIdAction] = {
          id: mittelIdAction, name: action.mittelName, dataKey: action.mittelKey, mittelmenge: 0.0, mittelmengeProHa: 0, naehrstoffe: naehrstoffe, alleNaehrstoffeId: alleNaehrstoffeId,
        };

        state.summe.alleMittelId.push(mittelIdAction);
      }

      const abschnitteNeu = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => {
        if (!a.alleMittelId.includes(mittelIdAction)) {
          a.alleMittelId.push(mittelIdAction);

          a.mittel[mittelIdAction] = {
            id: mittelIdAction, name: action.mittelName, dataKey: action.mittelKey, mittelmenge: 0.0, mittelmengeProHa: 0, naehrstoffe: naehrstoffe, alleNaehrstoffeId: alleNaehrstoffeId,
          };
        }

        return {
          ...a, mittel: a.alleMittelId.map(mittelId => a.mittel[mittelId]).map(mittel => {
            if (mittel.id !== mittelIdAction) {
              return {...mittel};
            }

            //abrunden
            const mittelmengeNeu = roundMittelmenge(a.flaeche / flaecheGesamt * mittelmenge, DUENGUNG_MITTELMENGE_GESAMT_MITTELMENGE_ABSCHNITT_AUFRUNDEN);
            const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeNeu * 10000 / a.flaeche);

            return {
              ...mittel, mittelmenge: mittelmengeNeu, mittelmengeProHa: mittelmengeProHaNeu, naehrstoffe: mittel.alleNaehrstoffeId.map(id => mittel.naehrstoffe[id]).map(n => ({
                ...n, naehrstoffmenge: roundMittelmenge(n.gehalt * mittelmengeNeu / 100), naehrstoffmengeProHa: roundMittelmengeProHa(n.gehalt * mittelmengeNeu * 100 / a.flaeche),
              })).reduce((alle, mittel) => ({...alle, [mittel.id]: mittel}), {}),
            };

          }).reduce((alleMittel, m) => ({
            ...alleMittel, [m.id]: m,
          }), {}),

        };

      }).reduce((alle, abschnitt) => ({...alle, [abschnitt.id]: abschnitt}), {});

      const summeNeu = duengung_recalculateSumme(state.summe, state.alleAbschnitteId, abschnitteNeu);

      const calcedData = {
        ...state, abschnitte: abschnitteNeu, summe: summeNeu,
      };

      if (action.previewData === true) {
        // Mittelmenge pro ha
        $('input.sumMengeHaGui').val(roundMittelmengeProHaGui(calcedData.summe.mittel[mittelIdAction].mittelmengeProHa));
        $('input.sumMengeHa').val(calcedData.summe.mittel[mittelIdAction].mittelmengeProHa);

        // Nährstoffe
        if (calcedData.summe.mittel[mittelIdAction].naehrstoffe) {
          $.each(calcedData.summe.mittel[mittelIdAction].naehrstoffe, function(k, v) {
            $('div.naehrstoff-row[data-naehrstoff-id="' + v.id + '"]').find('input.naehrstoff-input').val(roundMittelmengeGui(v.naehrstoffmenge));
          });
        }
      }

      return calcedData;
    }

      // mittelmenge pro ha summenzeile
    case 'SUMME_DUENGUNG_MITTELMENGE_PRO_HA_CHANGING': {
      const mittelIdAction = action.mittelKey + '-' + action.mittelId;
      const mittelmengeProHa = roundMittelmengeProHaGui(Number(action.mittelmengeProHa));
      if (typeof action.noCalc_sumMengeHa === 'undefined') {
        $('input.sumMittelmengeProHa').val(mittelmengeProHa);
      }

      // Nährstoffe
      const naehrstoffe = {};
      const alleNaehrstoffeId = [];
      $('div.naehrstoff-gehalt').not('.display-none').each(function() {
        const naherstoffID = $(this).data('naehrstoff-id');

        alleNaehrstoffeId.push(naherstoffID);
        naehrstoffe[naherstoffID] = {
          id: naherstoffID, gehalt: Number($(this).find('input.naehrstoff-prozent').val()),
        };
      });

      if (!state.summe.mittel[mittelIdAction]) {
        state.summe.mittel[mittelIdAction] = {
          id: mittelIdAction, name: action.mittelName, dataKey: action.mittelKey, mittelmenge: 0.0, mittelmengeProHa: 0, naehrstoffe: naehrstoffe, alleNaehrstoffeId: alleNaehrstoffeId,
        };

        state.summe.alleMittelId.push(mittelIdAction);
      }

      const abschnitteNeu = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => {
        if (!a.alleMittelId.includes(mittelIdAction)) {
          a.alleMittelId.push(mittelIdAction);

          a.mittel[mittelIdAction] = {
            id: mittelIdAction, name: action.mittelName, dataKey: action.mittelKey, mittelmenge: 0.0, mittelmengeProHa: 0, naehrstoffe: naehrstoffe, alleNaehrstoffeId: alleNaehrstoffeId,
          };
        }

        return {
          ...a, mittel: a.alleMittelId.map(mittelId => a.mittel[mittelId]).map(mittel => {
            if (mittel.id !== mittelIdAction) {
              return {...mittel};
            }

            //abrunden
            const mittelmengeNeu = roundMittelmenge(mittelmengeProHa * a.flaeche / 10000, DUENGUNG_MITTELMENGE_PRO_HA_MITTELMENGE_ABSCHNITT_AUFRUNDEN);
            const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeNeu * 10000 / a.flaeche);

            return {
              ...mittel, mittelmenge: mittelmengeNeu, mittelmengeProHa: mittelmengeProHaNeu, naehrstoffe: mittel.alleNaehrstoffeId.map(id => mittel.naehrstoffe[id]).map(n => ({
                ...n, naehrstoffmenge: roundMittelmenge(n.gehalt * mittelmengeNeu / 100), naehrstoffmengeProHa: roundMittelmengeProHa(n.gehalt * 100 * mittelmengeNeu / a.flaeche),
              })).reduce((alle, mittel) => ({...alle, [mittel.id]: mittel}), {}),
            };

          }).reduce((alleMittel, m) => ({
            ...alleMittel, [m.id]: m,
          }), {}),

        };

      }).reduce((alle, abschnitt) => ({...alle, [abschnitt.id]: abschnitt}), {});

      const summeNeu = duengung_recalculateSumme(state.summe, state.alleAbschnitteId, abschnitteNeu);

      const calcedData = {
        ...state, abschnitte: abschnitteNeu, summe: summeNeu,
      };

      if (action.previewData === true) {
        // Mittelmenge
        $('input.sumMengeGesamtGui').val(roundMittelmengeGui(calcedData.summe.mittel[mittelIdAction].mittelmenge));
        $('input.sumMengeGesamt').val(calcedData.summe.mittel[mittelIdAction].mittelmenge);

        // Nährstoffe
        if (calcedData.summe.mittel[mittelIdAction].naehrstoffe) {
          $.each(calcedData.summe.mittel[mittelIdAction].naehrstoffe, function(k, v) {
            $('div.naehrstoff-row[data-naehrstoff-id="' + v.id + '"]').find('input.naehrstoff-input').val(roundMittelmengeGui(v.naehrstoffmenge));
          });
        }
      }

      return calcedData;
    }

      // mittelmenge pro ha summenzeile
    case 'SUMME_DUENGUNG_NAEHRSTOFFMENGE_PRO_HA_CHANGING': {
      const mittelIdAction = action.mittelKey + '-' + action.mittelId;
      const naehrstoffIdAction = action.naehrstoffId;
      const naehrstoffmengeProHa = roundMittelmengeProHaGui(Number(action.mittelmengeProHa));

      // Nährstoffe
      const naehrstoffe = {};
      const alleNaehrstoffeId = [];
      $('div.naehrstoff-gehalt').not('.display-none').each(function() {
        const naherstoffID = $(this).data('naehrstoff-id');

        alleNaehrstoffeId.push(naherstoffID);
        naehrstoffe[naherstoffID] = {
          id: naherstoffID, gehalt: Number($(this).find('input.naehrstoff-prozent').val()),
        };
      });

      if (!state.summe.mittel[mittelIdAction]) {
        state.summe.mittel[mittelIdAction] = {
          id: mittelIdAction, name: action.mittelName, dataKey: action.mittelKey, mittelmenge: 0.0, mittelmengeProHa: 0, naehrstoffe: naehrstoffe, alleNaehrstoffeId: alleNaehrstoffeId,
        };

        state.summe.alleMittelId.push(mittelIdAction);
      }

      const gehalt = state.summe.mittel[mittelIdAction].naehrstoffe[naehrstoffIdAction].gehalt;

      const abschnitteNeu = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => {
        if (!a.alleMittelId.includes(mittelIdAction)) {
          a.alleMittelId.push(mittelIdAction);

          a.mittel[mittelIdAction] = {
            id: mittelIdAction, name: action.mittelName, dataKey: action.mittelKey, mittelmenge: 0.0, mittelmengeProHa: 0, naehrstoffe: naehrstoffe, alleNaehrstoffeId: alleNaehrstoffeId,
          };
        }

        return {
          ...a, mittel: a.alleMittelId.map(mittelId => a.mittel[mittelId]).map(mittel => {
            if (mittel.id !== mittelIdAction) {
              return {...mittel};
            }

            //abrunden
            const mittelmengeNeu = roundMittelmenge(naehrstoffmengeProHa / gehalt * a.flaeche / 100, DUENGUNG_NAEHRSTOFFMENGE_PRO_HA_MITTELMENGE_ABSCHNITT_AUFRUNDEN);
            const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeNeu * 10000 / a.flaeche);

            return {
              ...mittel, mittelmenge: mittelmengeNeu, mittelmengeProHa: mittelmengeProHaNeu, naehrstoffe: mittel.alleNaehrstoffeId.map(id => mittel.naehrstoffe[id]).map(n => ({
                ...n, naehrstoffmenge: roundMittelmenge(n.gehalt * mittelmengeNeu / 100), naehrstoffmengeProHa: roundMittelmengeProHa(n.gehalt * mittelmengeNeu * 100 / a.flaeche),
              })).reduce((alle, mittel) => ({...alle, [mittel.id]: mittel}), {}),
            };

          }).reduce((alleMittel, m) => ({
            ...alleMittel, [m.id]: m,
          }), {}),

        };

      }).reduce((alle, abschnitt) => ({...alle, [abschnitt.id]: abschnitt}), {});

      const summeNeu = duengung_recalculateSumme(state.summe, state.alleAbschnitteId, abschnitteNeu);

      const calcedData = {
        ...state, abschnitte: abschnitteNeu, summe: summeNeu,
      };

      if (action.previewData === true) {
        // Mittelmenge
        $('input.sumMengeGesamtGui').val(roundMittelmengeGui(calcedData.summe.mittel[mittelIdAction].mittelmenge));
        $('input.sumMengeGesamt').val(calcedData.summe.mittel[mittelIdAction].mittelmenge);

        // Mittelmenge pro ha
        $('input.sumMengeHaGui').val(roundMittelmengeProHaGui(calcedData.summe.mittel[mittelIdAction].mittelmengeProHa));
        $('input.sumMengeHa').val(calcedData.summe.mittel[mittelIdAction].mittelmengeProHa);

        // Nährstoffe
        if (calcedData.summe.mittel[mittelIdAction].naehrstoffe) {
          $.each(calcedData.summe.mittel[mittelIdAction].naehrstoffe, function(k, v) {
            if (v.id !== naehrstoffIdAction) {
              $('div.naehrstoff-row[data-naehrstoff-id="' + v.id + '"]').find('input.naehrstoff-input').val(roundMittelmengeGui(v.naehrstoffmenge));
            } else {
              $('div.naehrstoff-row[data-naehrstoff-id="' + v.id + '"]').find('input.naehrstoff-input-intern-' + v.id + '').val(roundMittelmenge(v.naehrstoffmenge));
            }
          });
        }
      }

      return calcedData;
    }

      // abschnitt bruehmenge
    case 'RESET_DUENGUNG_BRUEHE': {
      Object.keys(state.abschnitte).forEach(key => {
        var mittel = state.abschnitte[key]['mittel'];
        Object.keys(mittel).forEach(key2 => {
          $('.section-detail-mittel[data-psm-id="' + mittel[key2]['psmID'] + '"][data-psm-key="' + mittel[key2]['dataKey'] + '"][data-section-uid="' + mittel[key2]['sectionID'] + '"]').find('.spray-amount-abschnitt').val(mittel[key2]['mittelmenge']);
        });
      });

      return true;
    }
  }
};

/**
 * duengung_recalcRowMittel
 */
window.duengung_recalcRowMittel = function(preload = false) {
  const abschnittData = duengung_buildAbschnittData(preload);
  if ($.isEmptyObject(abschnittData.abschnitte) === false) {
    // Mittelsumme
    $.each(abschnittData.summe.mittel, function(key, value) {
      const mittelRow = $('#table-mittel').find('*[data-psm-id="' + value.psmID + '"][data-psm-key="' + value.dataKey + '"]');
      if (mittelRow.length > 0) {
        // Template
        let template = mittelRow.html();

        // Einheit
        const einheitName = mittelRow.find('.list-einheitName').val();

        template = template.replace(new RegExp('__MENGE_GESAMT_GUI__', 'g'), numberFormat(value.mittelmenge, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName);
        template = template.replace(new RegExp('__MENGE_HA_GUI__', 'g'), numberFormat(value.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_PRO_HA_GUI, ',', '.') + ' ' + einheitName);

        mittelRow.html(template);

        mittelRow.find('.list-mengeGesamtGui').html(numberFormat(value.mittelmenge, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName).removeClass('display-none');
        mittelRow.find('.list-mengeHaGui').html(numberFormat(value.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName).removeClass('display-none');
      }
    });

    // Abschnittsdaten
    $.each(abschnittData.abschnitte, function(key, value) {
      $.each(value.mittel, function(keyMittel, valueMittel) {
        const mittelAbschnittRow = $('.table-mittel-abschnitt').find('*[data-section-uid="' + valueMittel.sectionID + '"][data-psm-id="' + valueMittel.psmID + '"][data-psm-key="' + valueMittel.dataKey + '"]');
        if (mittelAbschnittRow.length > 0) {
          // Template
          let template = mittelAbschnittRow.html();

          // Einheit
          const einheitName = mittelAbschnittRow.find('.listAbschnitt-einheitName').val();

          template = template.replace(new RegExp('__MENGE_GESAMT_GUI__', 'g'), numberFormat(valueMittel.mittelmenge, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName);
          template = template.replace(new RegExp('__MENGE_GESAMT__', 'g'), valueMittel.mittelmenge, DECIMAL_PLACES_MITTELMENGE);

          template = template.replace(new RegExp('__MENGE_HA_GUI__', 'g'), numberFormat(valueMittel.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName);
          template = template.replace(new RegExp('__MENGE_HA__', 'g'), valueMittel.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_PRO_HA);

          mittelAbschnittRow.html(template);

          mittelAbschnittRow.find('.list-mengeGesamtGui').html(numberFormat(valueMittel.mittelmenge, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName).removeClass('display-none');
          mittelAbschnittRow.find('.list-mengeHaGui').html(numberFormat(valueMittel.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName).removeClass('display-none');
        } else {
          // Abschnittsmittel neu erstellens

          // Mittelrow
          const mittelRow = $('#table-mittel').find('*[data-psm-id="' + valueMittel.psmID + '"][data-psm-key="' + valueMittel.dataKey + '"]');
          const detailTable = $('.tree-item[data-section-uid="' + valueMittel.sectionID + '"]').find('div.table-mittel-abschnitt');

          // Template
          let template = $('#mittel-abschnitt-row').html();

          // Einheit
          const einheitName = mittelRow.find('.list-einheitName').val();

          // Replace
          template = template.replace(new RegExp('__KEY__', 'g'), 'NEW_' + rand());
          template = template.replace(new RegExp('__SECTION_ID__', 'g'), valueMittel.sectionID);
          template = template.replace(new RegExp('__PSM_ID__', 'g'), valueMittel.psmID);
          template = template.replace(new RegExp('__PSM_KEY__', 'g'), valueMittel.dataKey);
          template = template.replace(new RegExp('__ROW_ID__', 'g'), mittelRow.data('row-key'));
          template = template.replace(new RegExp('__PSM_NAME__', 'g'), valueMittel.name);
          template = template.replace(new RegExp('__MENGE_GESAMT__', 'g'), valueMittel.mittelmenge);
          template = template.replace(new RegExp('__MENGE_EINHEIT_NAME__', 'g'), einheitName);
          template = template.replace(new RegExp('__MENGE_GESAMT_GUI__', 'g'), numberFormat(valueMittel.mittelmenge, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName);
          template = template.replace(new RegExp('__MENGE_GESAMT__', 'g'), valueMittel.mittelmenge, DECIMAL_PLACES_MITTELMENGE);
          template = template.replace(new RegExp('__MENGE_HA_GUI__', 'g'), numberFormat(valueMittel.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName);
          template = template.replace(new RegExp('__MENGE_HA__', 'g'), valueMittel.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_PRO_HA);
          template = template.replace(new RegExp('__MENGE_GESAMT_CLASS__', 'g'), '');
          template = template.replace(new RegExp('__MENGE_HA_CLASS__', 'g'), '');

          // Create new line or replace
          const mittelAbschnittRow = detailTable.find('div[data-section-uid="' + valueMittel.sectionID + '"][data-psm-id="' + valueMittel.psmID + '"][data-psm-key="' + valueMittel.dataKey + '"]');
          if (mittelAbschnittRow.length > 0) {
            mittelAbschnittRow.replaceWith(template);
          } else {
            detailTable.append(template);
          }

          // overwrite values
          const newMittelAbschnittRow = detailTable.find('div[data-section-uid="' + valueMittel.sectionID + '"][data-psm-id="' + valueMittel.psmID + '"][data-psm-key="' + valueMittel.dataKey + '"]');
          newMittelAbschnittRow.find('.list-mengeGesamtGui').html(numberFormat(valueMittel.mittelmenge, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName).removeClass('display-none');
          newMittelAbschnittRow.find('.list-mengeHaGui').html(numberFormat(valueMittel.mittelmengeProHa, DECIMAL_PLACES_MITTELMENGE_GUI, ',', '.') + ' ' + einheitName).removeClass('display-none');
        }
      });
    });
  }
};

/**
 * duengung_openMittelDialog
 * @param element
 * @param recordID
 * @returns {boolean}
 */
window.duengung_openMittelDialog = function(element, recordID) {
  ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.addMittelDuengung', 500, {
    post_data: {
      data: $(element).closest('div.row').find('input').serializeObject(),
      recordID: recordID,
      additionalData: getCultureQuality(),
    },
  });
  return false;
};

/**
 * duengung_removeMittel
 * @param element
 */
window.duengung_removeMittel = function(element) {
  const elementDiv = $(element).closest('div.row');

  // Aktuelle Zeile entfernen
  $(element).closest('div.row').remove();
  $('#list_aufzeichnungFlaechenDuengung').find('div.table-mittel-abschnitt').find('div[data-psm-id="' + elementDiv.data('psm-id') + '"][data-psm-key="' + elementDiv.data('psm-key') + '"]').remove();

  duengung_removeLastStep();
  duengung_bindSetAdditionalText();
};

/**
 * duengung_bindAddMittel
 */
window.duengung_bindAddMittel = function() {
  initTooltip();

  $('input, select, textarea').keypress(function(event) {
    // 10 is for mac
    if (event.keyCode === 13 || event.keyCode === 10) {
      event.preventDefault();
      $(this).closest('div').next().find('input, select, textarea').focus();
    }
  });

  // Calc
  const psmRow = $('.psm-mittel-row');
  $('input.sumMengeGesamtWirtschaftsduengerGui').on('keyup change paste', function() {
    let mittelmenge = $(this).val() * 1000;
    if (Number($('input.ce_group').val()) === WIRTSCHAFTSDUENGER_FEST_CE_GROUP) {
      mittelmenge /= 1.2;
    }
    mittelmenge = roundMittelmengeGui(mittelmenge);
    $('input.sumMengeGesamtGui').val(mittelmenge);
    $('input.sumMengeGesamt').val(mittelmenge);
    duengung_calc(duengung_buildAbschnittData(), {
      type: 'SUMME_DUENGUNG_MITTELMENGE_CHANGING', previewData: true, mittelId: psmRow.data('psm-id'), mittelKey: psmRow.data('key'), mittelmenge: mittelmenge,
    });

    psmRow.find('.last-edit-field').val('mengeGesamt');
  });

  $('input.sumMengeGesamtGui').on('keyup change paste', function() {
    duengung_calc(duengung_buildAbschnittData(), {
      type: 'SUMME_DUENGUNG_MITTELMENGE_CHANGING', previewData: true, mittelId: psmRow.data('psm-id'), mittelKey: psmRow.data('key'), mittelmenge: $(this).val(),
    });

    psmRow.find('.last-edit-field').val('mengeGesamt');
  });

  $('input.sumMengeHaGui').on('keyup change paste', function() {
    duengung_calc(duengung_buildAbschnittData(), {
      type: 'SUMME_DUENGUNG_MITTELMENGE_PRO_HA_CHANGING', previewData: true, mittelId: psmRow.data('psm-id'), mittelKey: psmRow.data('key'), mittelmengeProHa: $(this).val(),
    });

    psmRow.find('.last-edit-field').val('mengeHa');
  });

  $('input.naehrstoff-input').on('keyup change paste', function() {
    const naehrstoffID = $(this).closest('.naehrstoff-row').data('naehrstoff-id');

    duengung_calc(duengung_buildAbschnittData(), {
      type: 'SUMME_DUENGUNG_NAEHRSTOFFMENGE_PRO_HA_CHANGING', previewData: true, mittelId: psmRow.data('psm-id'), mittelKey: psmRow.data('key'), naehrstoffId: naehrstoffID, mittelmengeProHa: $(this).val(), noCalc_Naehrstoff: true,
    });

    psmRow.find('.last-edit-field').val('naehrstoff_' + naehrstoffID);
  });

  if (psmRow.find('input.psm_mittel_uid').val() !== '') {
    duengung_calc(duengung_buildAbschnittData(), {
      type: 'SUMME_DUENGUNG_MITTELMENGE_CHANGING', previewData: true, mittelId: psmRow.data('psm-id'), mittelKey: psmRow.data('key'), mittelmenge: $('.sumMengeGesamt').val(),
    });
  }
};

/**
 * duengung_removeLastStep
 */
window.duengung_removeLastStep = function() {
  const formID = '#duengung';

  $('.accordion__kontrollen .accordion__item__body').remove();
  $('.accordion__kontrollen .accordion__item__title').addClass('form-submit').attr('onclick', 'insertAutoLoader(); $(\'' + formID + '\').trigger(\'submit\'); return false;');

  const buttonTriggerSubmit = $('button#trigger-submit');
  buttonTriggerSubmit.find('span').html(LANG_STRINGS.weiter);
  buttonTriggerSubmit.attr('onclick', 'insertAutoLoader(); $(\'' + formID + '\').trigger(\'submit\'); return false;');

  duengung_bindSetAdditionalText();
};

/**
 * duengung_bindRemoveLastStep
 */
window.duengung_bindRemoveLastStep = function() {
  $('form#duengung').find('input, select, textarea').change(function() {
    duengung_removeLastStep();
  });
};

/**
 * duengung_goToError
 * @param element
 */
window.duengung_goToError = function(element) {
  const sectionID = $(element).attr('data-section-id');
  if (sectionID) {
    const foundRow = $('#list_aufzeichnungFlaechenDuengung').find('div.tree-item[data-section-uid=' + sectionID + ']');
    if (!foundRow.closest('div.accordion__item').hasClass('accordion__item--active')) {
      foundRow.closest('div.accordion__item').find('div.accordion__item__title').trigger('click');
    }

    if (!foundRow.hasClass('tree-item--active')) {
      foundRow.find('div.tree-item__heading__trigger').trigger('click');
    }

    $('html, body').animate({
      scrollTop: parseInt(foundRow.find('div.tree-item__heading__trigger').offset().top) - 40,
    }, 100);
  }
};

/**
 * duengung_bindChangingFields
 * @param recordID
 * @param savedDate
 */
window.duengung_bindChangingFields = function(recordID, savedDate) {
  let timeout = null;

  // Change Date
  $('#aufzeichnung-einsatzdatum-start').on('keyup change', function() {
    const element = this;
    const currentDate = $(element).val();
    const savedTime = $('#aufzeichnung-einsatzzeit-von').val();

    if (currentDate !== savedDate) {
      $('#trigger-submit').attr('disabled', 'disabled');

      clearTimeout(timeout);
      timeout = setTimeout(function() {
        if (currentDate) {
          try {
            const parsedCurrentDate = new Date(currentDate);
            const parsedSavedDate = new Date(savedDate);
            if (parsedCurrentDate.getFullYear() !== parsedSavedDate.getFullYear()) {
              ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.editEingabeDateYear?type=duengung&recordID=' + recordID + '&savedDate=' + savedDate + '&currentDate=' + currentDate + '&savedTime=' + savedTime);
            } else {
              $.ajax({
                url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.checkChangeDate',
                data: {
                  type: 'duengung',
                  recordID: recordID,
                  savedDate: savedDate,
                  currentDate: currentDate,
                  savedTime: savedTime,
                },
                dataType: 'json',
                type: 'get',
                success: function(returnValue) {
                  if (returnValue['success']) {
                    if (returnValue['reload']) {
                      location.reload();
                    } else {
                      $('#fromEditDate').val(1);
                      $('form.form-record').submit();
                    }
                  } else {
                    ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.editEingabeDate?type=duengung&savedDate=' + savedDate);
                  }
                },
              });
            }
          } catch (e) {
          }
        }

        $('#trigger-submit').removeAttr('disabled');
      }, 1000);
    }
  });

  // Change Culture
  $('.culture-checkbox').on('click', function() {
    const action = $(this).is(':checked') ? 'check' : 'uncheck';
    const kulturID = $(this).val();

    if (action === 'uncheck') {
      ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.editEingabeCultureChange?type=duengung&kulturID=' + kulturID + '&recordID=' + recordID);
    } else {
      $.ajax({
        url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.setEingabeCulture', data: {
          type: 'duengung', recordID: recordID, kulturID: kulturID, action: action,
        }, dataType: 'json', type: 'post', success: function() {
          window.location.reload();
        },
      });
    }
  });
};

/**
 * duengung_bindSetWirtschaftsjahrOnChangeAbschnitte
 */
window.duengung_bindSetWirtschaftsjahrOnChangeAbschnitte = function() {
  $('#list_aufzeichnungFlaechenDuengung input:checkbox, #check-all').on('change', function() {
    let abschnitte = [];
    $('input.check_section:checked').each(function() {
      abschnitte.push($(this).val());
    });
    $.ajax({
      url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.getWirtschaftsjahr',
      data: {
        abschnitte,
        date: $('#aufzeichnung-einsatzdatum-start').val(),
      },
      dataType: 'json',
      type: 'post',
      success: function(response) {
        let marketingYearSelector = $('#marketing-year');
        if (marketingYearSelector.val() != response['year']) {
          ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.contentWarningWirtschaftsjahrAenderung?old=' + marketingYearSelector.val() + '&new=' + response['year'] + '&abschnitte=' + response['abschnitte']);
        }
        marketingYearSelector.val(response['year']);
      },
    });
  });
};

/**
 * duengung_setAccordionField
 * @param type
 * @returns {string|*}
 */
window.duengung_setAccordionField = function(type) {
  if (type === 'recordType') {
    const inputChecked = $('.record-type').find('input[type="radio"]:checked');
    return inputChecked.closest('label').find('.label').text();
  }

  if (type === 'kulturen') {
    const kulturNames = [];
    $('#kultur-list').find('input[type="checkbox"]:checked').each(function() {
      kulturNames.push($(this).closest('label').data('string'));
    });

    return kulturNames.join(', ');
  }

  if (type === 'datum') {
    const date = new Date($('#aufzeichnung-einsatzdatum-start').val());
    return date.toLocaleDateString('de-DE', {
      day: '2-digit', month: '2-digit', year: 'numeric',
    });
  }

  if (type === 'flaeche') {
    const abschnittData = duengung_buildAbschnittData();
    return numberFormat(abschnittData.summe.flaeche / 10000, DECIMAL_PLACES_FLAECHE_HA_GUI, ',', '.') + ' ha';
  }

  if (type === 'mittel') {
    const psmNames = [];
    $('#table-mittel').find('.list-mittelName').each(function() {
      psmNames.push($(this).val());
    });

    return psmNames.join(', ');
  }
};

/**
 * duengung_bindSetAdditionalText
 */
window.duengung_bindSetAdditionalText = function() {
  const duengungLayout = $('#duengung');
  duengungLayout.find('div.accordion__item__title__additional').each(function() {
    // Set RecordType
    if ($(this).find('.sub-record-type').length > 0) {
      $(this).find('.sub-record-type').html(duengung_setAccordionField('recordType'));
    }

    // Set Kulturen
    if ($(this).find('.sub-kulturen').length > 0) {
      $(this).find('.sub-kulturen').html(duengung_setAccordionField('kulturen'));
    }

    // Set Datum
    if ($(this).find('.sub-datum').length > 0) {
      $(this).find('.sub-datum').html(duengung_setAccordionField('datum'));
    }

    // Set Fläeche
    if ($(this).find('.sub-flaeche').length > 0) {
      $(this).find('.sub-flaeche').html(duengung_setAccordionField('flaeche'));
    }

    // Set Mittel
    if ($(this).find('.sub-mittel').length > 0) {
      $(this).find('.sub-mittel').html(duengung_setAccordionField('mittel'));
    }
  });

  duengungLayout.find('div.accordion__item__title__additional').removeClass('display-none');
};

/**
 * duengung_bindAddMittelAbschnitt
 */
window.duengung_bindAddMittelAbschnitt = function() {
  initTooltip();
};

// Document-Ready
$(function() {
  if (MODULE_FILE === 'duengung') {
    // Recalc Eingesetzte Mittel
    duengung_recalcRowMittel(true);

    // Bind duengung_bindRemoveLastStep
    duengung_bindRemoveLastStep();
  }
});